import { addBusinessDays, format, isAfter, isSameDay } from 'date-fns'
import { Availabilities } from '@customTypes/Availabilities'

export interface GroupedAvailabilityMonth {
  fromDate: Date
  toDate: Date
  weeks: Availabilities[][]
}

export const groupAvailabilitiesByWeeks = (
  availabilities: Availabilities[],
  fromDate: Date,
  toDate: Date
): GroupedAvailabilityMonth => {
  const datesInRange: Date[] = []
  let currentDate = fromDate
  while (!isAfter(currentDate, toDate)) {
    datesInRange.push(currentDate)
    currentDate = addBusinessDays(currentDate, 1)
  }

  const availabilitiesMappedToDaysFromRange = datesInRange.map((date) => {
    const matchingAvailability = availabilities.find((availability) => {
      return isSameDay(new Date(availability.date), date)
    })
    return {
      date: format(date, 'yyyy-MM-dd'),
      availabilities: matchingAvailability?.availabilities ?? [],
    }
  })

  const availabilitiesGroupedByWeeks = []

  while (availabilitiesMappedToDaysFromRange.length) {
    availabilitiesGroupedByWeeks.unshift(availabilitiesMappedToDaysFromRange.splice(-5))
  }

  return {
    fromDate,
    toDate,
    weeks: availabilitiesGroupedByWeeks,
  }
}
